module.exports = __webpack_public_path__ + "static/media/brand-library-fonts-empty.8ab9ca04.svg";